module.exports = __webpack_public_path__ + "static/media/Yoga_por_Inteiro_Svanasana.78eb4850.png";